import { Button, Flex, Image, Text } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ReactToPrint from 'react-to-print'
import useApp from '../context/AppContext'

function PrintTeam() {

    const {players} = useApp()
    let componentRef = useRef()
    const location = useLocation()
    const [team,setTeam] = useState(location.state.team)

    useEffect(() => {

        if(team && players)
        {
            console.log(team)
            team.players.sort((a,b) => (players?.players[a]?.category > players?.players[b]?.category)?1:-1)
            setTeam({...team})
        }

    }, [players])

    return (

        <Flex
            direction={'column'}
            p={2}
        >

            <ReactToPrint
                trigger={() => <Button id={'button'}>Print</Button>}
                content={() => componentRef}
            />

        <Flex
            direction={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            ref={el => (componentRef=el)}
            p={3}
        >   
            <Text
                marginBottom={5}
                fontSize={'26px'}
                fontWeight={500}
            >{team.name}</Text>

            <Flex
                wrap={'wrap'}
                justifyContent="space-evenly"
                gap={2}
            >
                {team.players.map(p => {
                    return (
                        <Flex
                            minW={'240px'}
                            border={'1px'}
                            direction='column'
                            textAlign={'center'}
                            fontWeight={'500'}
                        >
                                <Text 
                                    bg={'red.700'}
                                    fontWeight={'500'}
                                    color={'white'}
                                >
                                    {players?.players[p]?.name}
                                </Text>
                                <Flex>

                                    <Image 
                                        w={"120px"}
                                        h={'150px'}
                                        border={'1px'}
                                        src={players?.players[p]?.image}
                                    />
                                    <Flex
                                        direction={'column'}
                                        textAlign={'center'}
                                        alignItems="center"
                                        justifyContent={'space-evenly'}
                                        marginX={'auto'}
                                    >
                                        
                                        <Text>{players?.players[p]?.mid}</Text>
                                        <Text>{players?.players[p]?.category}</Text>
                                        <Text>{players?.players[p]?.phone}</Text>
                                    </Flex>

                                </Flex>
                        </Flex>
                    )
                })}

            </Flex>

        </Flex>

        </Flex>
    )
}

export default PrintTeam